import styles from '@features/productPreview/sections/UniversalShoppingValues/ShoppingValues.styles';
import Heading from '@components/Heading/Heading';
import sanitizeHtml from '@utils/sanitizeHtml';
import Icon from '@components/icons/Icon';
import { TUSPItemType } from '@features/cms/typescript';
import Button from '@components/Button/Button';
import scrollToElementById from '@utils/scrollToElementById';
import prepareURLByCMSLink from '@utils/prepareURLByCMSLink';
type PropsType = {
  data: TUSPItemType;
};
const IconWithText = ({
  data
}: PropsType) => {
  const {
    icon,
    title,
    content,
    link,
    buttonText
  } = data;
  const renderContent = () => <>
      <div sx={styles.iconWrapper}>
        <Icon icon={icon} size="60px" />
      </div>
      <Heading h={6} headingType={6} mobile align="center">
        {title}
      </Heading>
      {content && <div sx={styles.text} dangerouslySetInnerHTML={sanitizeHtml(content)} data-cy="IconWithTextContent" />}
    </>;
  const hashtag = link?.path ? link?.path?.slice(0, 1) === '#' : false;
  const renderButton = () => {
    if (link && !hashtag && link?.path) {
      return <Button variantColor="dark" size="small" addSx={styles.button} variant="outlined" addClassName="info_block-button" href={prepareURLByCMSLink(link)} openInNewTab={link?.properties?.target === '_blank'}>
          {buttonText}
        </Button>;
    }
    return <Button variantColor="dark" size="small" addSx={styles.button} variant="outlined" addClassName="info_block-button" onClick={() => hashtag && link?.path ? scrollToElementById(link?.path?.substring(1)) : null}>
        {buttonText}
      </Button>;
  };
  return <div sx={styles.shoppingValueContainer} data-cy="IconWithText">
      {renderContent()}
      {buttonText && renderButton()}
    </div>;
};
export default IconWithText;